module.exports = __webpack_public_path__ + "static/media/varais-15-copia.0ba98e12.jpg";